import {useEffect} from 'react'

const cacheImages = async (srcArray: string[]) => {
  const imagePromises = await srcArray.map(src => {
    return new Promise(resolve => {
      const img = new Image()
      img.src = src
      img.onload = () => resolve(true)
    })
  })
  await Promise.all(imagePromises)
}

export const usePreloadImages = (images: string[]) => {
  useEffect(() => {
    if (!images?.length) return
    cacheImages(images)
  }, [images?.[0]])
}
